<template>
  <div class="one-box">
    <div class="one-title">用户画像</div>
    <div class="one-part-box">
        <div class="userPeo">
          <div class="table-header table-row">
            <div class="table-cell" style="width: 30%;font-size:18px;margin-left:20px">用户占比</div>
            <div class="table-cell" style="width: 70%;font-size:18px">终端类型</div>
          </div>
          <div class="table-body">
            <div :class="{ 'scroll-wrap': phoneData.length > 0 }">
              <div
                class="table-row"
                :class="{ hasBgc: index % 2 === 0 }"
                v-for="(item, index) in phoneData"
                :key="index"
                :ref="'row_' + index"
              >
                <div
                  class="table-cell"
                  style="width: 30%;font-size:16px;margin-left:30px"
                  :title="item.proportion"
                >{{item.proportion}}</div>
                <div
                  class="table-cell"
                  style="width: 70%;font-size:16px"
                  :title="item.phone_model"
                >{{ item.phone_model }}</div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      initMt: 0,
      getPlayData: [
        { coreName: "123", publish: "111" },
        { coreName: "需求", publish: "页面" },
        { coreName: "效果图", publish: "接CV" },
        { coreName: "码即可出", publish: "条" },
        { coreName: "tooltip ", publish: "多展" },
        { coreName: "啊实打实", publish: "111" },
        { coreName: "嘻嘻嘻", publish: "11杀杀杀1" },
        { coreName: "全球", publish: "饿饿" },
        { coreName: "娃娃", publish: "日日日日" },
        { coreName: "123", publish: "111" },
        { coreName: "需求", publish: "页面" },
        { coreName: "效果图", publish: "接CV" },
        { coreName: "码即可出", publish: "条" },
        { coreName: "tooltip ", publish: "多展" },
        { coreName: "啊实打实", publish: "111" },
        { coreName: "嘻嘻嘻", publish: "11杀杀杀1" },
        { coreName: "全球", publish: "饿饿" },
        { coreName: "娃娃", publish: "日日日日" },
        { coreName: "123", publish: "111" },
        { coreName: "需求", publish: "页面" },
        { coreName: "效果图", publish: "接CV" },
        { coreName: "码即可出", publish: "条" },
        { coreName: "tooltip ", publish: "多展" },
        { coreName: "啊实打实", publish: "111" },
        { coreName: "嘻嘻嘻", publish: "11杀杀杀1" },
        { coreName: "全球", publish: "饿饿" },
        { coreName: "娃娃", publish: "日日日日" }
      ],
      visible: true,
      stop: false
    };
  },
  methods: {
    play() {
      const row = this.$refs["row_0"][0];
      setTimeout(() => {
        this.visible = false;

        this.$nextTick(() => {
          this.initMt++;
          if (this.initMt === this.data.length) {
            this.initMt = 0;
          }
          this.visible = true;
        });
        this.play();
      }, 2000);
    }
  },
  computed: {
    phoneData: function() {
      return this.$store.getters.getState("phoneData");
    }
  }
  // watch: {
  //       phoneData: function (newVal, oldVal) {
  //       console.log(newVal,"newVal==========>")
  //       }
  // },
};
</script>
<style lang="scss" scoped>
$cellHeight: 35px;
.table-row {
  display: flex;
  line-height: 60px;
  height: 60px;
  transition: all 0.3s;
  border-bottom: 1px solid rgba(63, 88, 114, 1);
}
.table-header {
  color: #fff;
  text-shadow: 1px 1px 3px #678ceb;
  font-weight: normal;
}
.table-cell {
  text-align: left;
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.hasBgc {
  background: rgba(63, 52, 95, 0.37) ;
}
.hidden-row {
  height: 0 !important;
  line-height: 0 !important;
  display: none !important;
}
.table-body {
  height: 100%;
  overflow-y: hidden;
  .table-row {
    color: #fff;
  }
}
.scroll-wrap {
  animation: scroll 18s linear infinite;
  position: relative;
}
.scroll-wrap:hover {
  animation-play-state: paused;
}
@keyframes scroll {
  from {
    top: 0;
  }
  to {
    top: -8 * $cellHeight;
  }
}
.one-box {
}
</style>



// WEBPACK FOOTER //
// src/views/moudles/InstallMoudle.vue